export default __webpack_public_path__ + "static/media/IMG-20241005-WA0021.3b32d5b6.jpg";